<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="3000013" />

    <section slot="titleRight">
      <qx-permpisions permpisions="70019005">
        <ImportBtn
          title="车辆GPS信息导入"
          bizCodes="imp1000106"
          :isDownloadLocalTemplate="true"
          fileUrl="/file/GPS台账导入.xlsx"
          btnName="导入"
          type="getImportTempFile"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="70019004">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleServiceBO.ajax?cmd=doQueryVehicleStandingBookInfoOut"
          :params="fullSearchData"
          bizName="GPS台账信息导出"
          bizCode="exp100076"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="70019001">
        <el-button type="primary" plain @click="() => toEdit(null, 'add')">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'plateNumber'"
          >
            <section slot-scope="scope">
              <section
                v-if="scope.column.property === 'busiCode'"
                @click="toBusiCodeDetail(scope.row)"
              >
                <span class="primary cur">
                  {{ scope.row[scope.column.property] }}
                </span>
              </section>
              <section
                v-else-if="scope.column.property === 'plateNumber'"
                @click="toCarDetail(scope.row)"
              >
                <span class="primary cur">
                  {{ scope.row[scope.column.property] }}
                </span>
              </section>
              <section
                  v-else-if="scope.column.property === 'drivingLicenseDate'"
              >
                <span >
                  {{  scope.row[scope.column.property]?(scope.row[scope.column.property]).substring(0,10):''}}
                </span>
              </section>
              <section v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </section>
            </section>
          </el-table-column>
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="140"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :isCenter="true"
                :btnList="[
                  {
                    permpisions: '70019002',
                    showCondition: scope.row.state !== 1,
                    name: '修改',
                    event: () => toEdit(scope.row, 'edit'),
                  },
                  {
                    permpisions: '70019003',
                    showCondition:
                      (scope.row.busiCode == '' ||
                        scope.row.busiCode == null) &&
                      scope.row.state != 1,
                    name: '取消',
                    event: () => toCancel(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '查看',
                    event: () => toEdit(scope.row, 'detail'),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.id),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import ImportBtn from 'components/importBtn';
import LogRightDialog from 'components/logRightDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  doQueryVehicleStandingBookInfoOut,
  cancelVehicleStandingBookInfo,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    ImportBtn,
    LogRightDialog,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { label: '车辆号码', prop: 'plateNumber' },
          { label: '车辆归属', prop: 'orgName' },
          { label: '配置', prop: 'vehicleOriginName' },
          { label: '车辆类型', prop: 'vehicleType' },
          { label: '车辆性质', prop: 'vehicleOwnerShipName' },
          { label: '品牌名称', prop: 'brandModel' },
          { label: '行驶证注册日期', prop: 'drivingLicenseDate' },
          { label: '年审月份', prop: 'annualVerificationMonth' },
          { label: '服务商', prop: 'serviceName' },
          { label: '设备号', prop: 'equipmentNumber' },
          { label: '失效日期', prop: 'serviveLoseDate' },
          { label: '套装类型', prop: 'suitTypeName' },
          { label: '油耗设备品牌', prop: 'oilWearEquoipmentBrand' },
          { label: '定位设备品牌', prop: 'gpsEquoipmentBrand' },
          { label: '油耗设备型号', prop: 'oilWearEquoipmentModel' },
          { label: '定位设备型号', prop: 'gpsEquoipmentModel' },
          { label: '油耗设备号', prop: 'oilWearEquoipmentNumber' },
          { label: '定位设备号', prop: 'gpsEquoipmentNumber' },
          { label: 'GPS套装费用（元）', prop: 'suitFeeDouble' },
          { label: '成交价（元）', prop: 'bargainFeeDouble' },
          { label: '创建时间', prop: 'createDate' },
          { label: '修改时间', prop: 'updateDate' },
          { label: '申请单号', prop: 'busiCode' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryVehicleStandingBookInfoOut,
    toBusiCodeDetail (item) {
      this.jump({
        label: '车辆费用',
        url: `/manage/cost/car/car?busiCode=${item.busiCode}`,
        full: true,
      });
    },
    toCarDetail (item) {
      const type = 'detail';
      this.jump({
        label: `查看车辆-${item.plateNumber}`,
        url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass || ''}&type=${type}`,
        full: true,
      });
    },
    async toCancel (item) {
      const confirmRes = await this.$confirm('是否确定取消台账？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await cancelVehicleStandingBookInfo({ id: item.id });
        this.getData();
      }
    },
    toEdit (item, type) {
      switch (type) {
        case 'add':
          this.jump({
            label: '新增GPS信息台账登记',
            url: '/manage/car/maintain/gps/edit',
            full: true,
          });
          break;
        case 'detail':
          this.jump({
            label: `查看GPS信息-${item.plateNumber}`,
            url: `/manage/car/maintain/gps/detail?id=${item.id}&type=detail`,
            full: true,
          });
          break;
        case 'edit':
          this.jump({
            label: '修改GPS信息台账登记',
            url: `/manage/car/maintain/gps/edit?id=${item.id}`,
            full: true,
          });
          break;
        default:
          break;
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
